module.exports = __webpack_public_path__ + "static/media/icon-sneak-peek.db03f0dd.png";